import { combineReducers } from '@reduxjs/toolkit';
import { emptyDeinVerbandApi, emptyPreflightApi } from 'src/api/empty-api';
import { getStreamApi } from 'src/api/getstream-api';

export const rootReducer = combineReducers({
  [emptyDeinVerbandApi.reducerPath]: emptyDeinVerbandApi.reducer,
  [emptyPreflightApi.reducerPath]: emptyPreflightApi.reducer,
  [getStreamApi.reducerPath]: getStreamApi.reducer
});
